module.exports = __webpack_public_path__ + "img/visual-data.c8624fb4.svg";